module.exports = "https://static.im-cdn.com/mjc/storefront/Anchor/static/media/SortTick.0a8b3f72.svg";